import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface MessageRecipientPairDto {
  MsgId: number;
  RecipientClientId: number;
}

interface UndeleteMessageRequest {
  clientId: string;
  messageIds: number[];
  isDeleteAction: boolean;
  origin?: string;
  messages?: any[];
}

const useUndeleteMessagesApi = (clientId: string, messageIds: number[], isDeleteAction: boolean, origin: string, messages?: any[]) => {  
      const call = useCallback(
          async (params?: UndeleteMessageRequest) => {
            try {
                const messageIdsToProcess = params?.messageIds || messageIds;
                // Ensure actionToTake is explicitly boolean
                const actionToTake = params?.isDeleteAction !== undefined ? params.isDeleteAction : isDeleteAction;
                const messageObjects = params?.messages || messages || [];
                
                const msgIdRecipientPairs: MessageRecipientPairDto[] = [];
                
                // If multiple message objects, process directly instead of trying to match by messageId
                if (messageObjects && messageObjects.length > 0) {
                  messageObjects.forEach((messageObj: any, index: number) => {                    
                    let recipientClientId: number;
                    if (messageObj.clientId) {
                      const rawClientId = messageObj.clientId;
                      recipientClientId = parseInt(String(rawClientId));
                    } else {
                      recipientClientId = 0;  //fallback (dummy) recipientClientId
                    }
                    
                    const pair = {
                      MsgId: messageObj.messageId,
                      RecipientClientId: recipientClientId
                    };
                    
                    msgIdRecipientPairs.push(pair);
                  });
                } else {
                  // Fallback to original logic if no message objects
                  for (let i = 0; i < messageIdsToProcess.length; i++) {
                    const msgId = messageIdsToProcess[i];
                    const pair = {
                      MsgId: msgId,
                      RecipientClientId: parseInt(clientId)
                    };
                    msgIdRecipientPairs.push(pair);
                  }
                }
                
                const clientIdToUse = params?.clientId || clientId;   // Use clientId parameter passed to the hook
                const originToUse = params?.origin || origin;
                const apiUrl = api.deleteUndeleteMessage(clientIdToUse, actionToTake, originToUse);
                
                const res = await axiosInstance.post(
                  apiUrl,
                  msgIdRecipientPairs
                );
                
                return res.data;
            } catch (error) {
              console.error('UndeleteMessage API - Error:', error);              
              throw error;
            }
          },
          [clientId, messageIds, isDeleteAction, origin, messages]
        );

        const { isLoading, execute, status } = useAsync(call, false);

        return {
          isLoading,
          undeleteMessage: execute, 
          undeleteMessageStatus: status,
        };
};

export default useUndeleteMessagesApi;

